<template>
    <b-row>
        <b-col cols="12">
            <div v-for="(section, sectionIndex) in forms" class="block--auth block--auth-large" :key="sectionIndex"
                 :style="`margin-left:1%;width:${((section.span ? section.span : 12) / 12 * 100)-1}%; display: inline-block;`"
                 v-if="section.fields && section.fields.length && isVisible(section)">
                <div class="block--auth-title">
                    {{ section.title }}
                </div>
                <div class="group--form">
                    <template v-if="section.tagName === 'ED'">
                        <b-row :key="`row-${sectionIndex}-${isinIndex}`" v-for="(isin, isinIndex) in isins">
                            <b-col :cols="12">
                                <template v-if="isin.label && isin.label.length">
                                    <h6 style="text-transform: uppercase;">{{ isin.label }}</h6>
                                </template>
                                <template v-else>
                                    <h6 style="text-transform: uppercase;">{{ isin.number }}</h6>
                                </template>
                                <p style="text-transform: uppercase;">{{ isin.descr }}</p>

                            </b-col>
                            <input type="hidden" :name="`formData[amounts][${isin.number}][ISIN]`" :value="isin.number">
                            <b-col :cols="field.span" v-for="(field, index) in section.fields" :key="index"
                                   :span="field.span" v-bind="field" class="form__group"
                                   v-if="field.fieldType !== 'NoticeComponent'">
                                <h5 v-if="field.tagname === 'AMOUNT'">
                                    {{ field.label }} <br><br><span style="display: block;">
                            <template v-if="localData['amounts'][isin.number][field.tagname]">
                              {{
                                    isin.currency ? isin.currency : field.prepend
                                }} {{
                                    parseFloat(localData['amounts'][isin.number][field.tagname]).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                                }}
                            </template>
                            <template v-else>
                                --
                            </template>
                          </span>
                                </h5>
                                <h5 v-else-if="field.tagname === 'ACCESSION'">
                                    {{ field.label }}<br><br><span style="display: block;">{{
                                        localData['amounts'][isin.number][field.tagname]
                                    }}</span>
                                    <div
                                        v-if="!isValidForRsa(localData['amounts'][isin.number].ISIN) && field.hasAccessionCodeValidation"
                                        style="color: red!important">The amount specified for this Accession Code does
                                        not match our records.  This may be due to a position held across multiple
                                        custodians.  You may continue with submission of the AHL, but you are advised to
                                        double check the amounts and Accession Code input.
                                    </div>
                                </h5>
                                <h5 v-else-if="field.tagname === 'REFNUM'">
                                    {{ field.label }}<br><br><span style="display: block;">{{
                                        localData['amounts'][isin.number][field.tagname]
                                    }}</span>
                                    <div
                                        v-if="!isValidForBondwatch(localData['amounts'][isin.number].ISIN) && field.hasBondWatchInstructionValidation"
                                        style="color: red!important">This data does not match our records.
                                    </div>
                                </h5>
                                <h5 v-else> {{ field.label }} <br><br><span style="display: block;">
                            <template v-if="currencyTags.indexOf(field.tagname) > -1 && localData['amounts'][isin.number][field.tagname]">
                                {{
                                    parseFloat(localData['amounts'][isin.number][field.tagname]).toFixed(field.decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }}
                            </template>
                            <template v-else>
                            {{ localData['amounts'][isin.number][field.tagname] }}
                            </template>
                        </span></h5>
                            </b-col>
                        </b-row>
                    </template>
                    <b-row :key="`row-${sectionIndex}`" v-else>
                        <b-col :cols="field.span" v-for="(field, index) in section.fields" :key="index"
                               :span="field.span" v-bind="field" class="form__group" v-if="isVisible(field)">
                            <RenderField :field="field" v-if="field.fieldType === 'NoticeComponent'">
                                <component
                                    style="margin:0!important"
                                    :is="field.fieldType"
                                    :currentField="field" class="form__field"
                                ></component>
                            </RenderField>
                            <RenderField :field="field" v-else-if="field.fieldType === 'HtmlComponent'">
                                <component
                                    style="margin:0!important"
                                    :is="field.fieldType"
                                    :currentField="field" class="form__field"
                                ></component>
                            </RenderField>
                            <RenderField :field="field" v-else-if="field.fieldType === 'ModalComponent'"></RenderField>
                            <template v-else>
                                <h5 v-if="Array.isArray(localData[field.tagname])"> {{ field.label }} <br><br><span
                                    style="display: block;">{{ localData[field.tagname].join(', ') }}</span></h5>
                                <h5 v-else-if="field.fieldType === 'Flag'">
                                    <input type="checkbox" disabled="" :checked="localData[field.tagname]"/>
                                    &nbsp;{{ field.label }} <br>
                                </h5>
                                <h5 v-else> {{ field.label }} <br><br><span
                                    style="display: block;">
                                    <template v-if="currencyTags.indexOf(field.tagname) > -1">
                                    {{parseFloat(localData[field.tagname]).toFixed(field.decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}
                                </template>
                                <template v-else>
                                {{ localData[field.tagname] }}
                                </template>
                                </span></h5>
                            </template>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <!-- </b-form> -->
        </b-col>
    </b-row>
</template>

<script>
import {FormBuilder} from '@/components/bs/formbuilder'
import RenderField from './RenderField'

export default {
    name: 'Publish',
    store: ['forms', 'themingVars'],
    props: ['standaloneForms', 'isins', 'formData', 'rsaCheckTable', 'instructionsCheckTable', 'currencyTags'],
    components: {
        ...FormBuilder.$options.components,
        RenderField
    },

    data() {
        return {
            visibility: {},
            localData: {}
        }
    },

    watch: {
        forms(value) {
            this.computeVisibility()
        }
    },

    methods: {

        isVisible(element) {
            // if(element.fieldType === 'HtmlComponent') {
            //   return true
            // }
            var tag = element.tagName ?? element.tagname

            var identifier = `${tag}-${element.id}`

            return this.visibility[identifier]
        },

        computeVisibility() {
            var map = {}

            this.forms.forEach(section => {
                var identifier = `${section.tagName}-${section.id}`
                map[identifier] = this.elementVisibilty(section)
                return section.fields.forEach(field => {
                    var identifier = `${field.tagname}-${field.id}`
                    map[identifier] = this.elementVisibilty(field)
                })
            })

            return this.visibility = map
        },

        elementVisibilty(element) {
            var result = element.conditions.visibility.map(condition => {
                if (condition.cond == "==") {
                    return this.localData[condition.actor] == condition.value
                }

                if (condition.cond == "!=") {
                    return this.localData[condition.actor] != condition.value
                }

                if (condition.cond == "**") {
                    return this.localData[condition.actor] != '' && this.localData[condition.actor] != null
                }

                if (condition.cond == "!!") {
                    return this.localData[condition.actor] == '' || this.localData[condition.actor] == null
                }

                if (condition.cond == "$$") {
                    return this.localData[condition.actor] == this.localData[condition.value] && this.localData[condition.actor] != '' && this.localData[condition.actor] != null  // && actorVisibility
                }

                if (condition.cond == "@@") {
                    return this.localData[condition.actor] != this.localData[condition.value]  // && actorVisibility
                }

                return true
            })

            if (result.length) {
                if (element.conditions.visibility_operand === 'AND') {
                    result = result.every(r => r)
                }

                if (element.conditions.visibility_operand === 'OR') {
                    result = result.some(r => r)
                }
            } else {
                result = true
            }

            return result
        },

        isValidForRsa(isin) {
            if (this.rsaCheckTable.length == 0) {
                return true
            }

            if (!Object.keys(this.rsaCheckTable).includes(isin)) {
                return false
            }

            return this.rsaCheckTable[isin].MATCHES
        },

        isValidForBondwatch(isin) {
            if (this.instructionsCheckTable.length == 0) {
                return true
            }

            if (!Object.keys(this.instructionsCheckTable).includes(isin)) {
                return false
            }

            return this.instructionsCheckTable[isin].MATCHES
        }
    },

    mounted() {
        this.localData = JSON.parse(this.formData)
        if (this.standaloneForms) {
            this.forms = JSON.parse(this.standaloneForms)
        }
    },

    computed: {
        formatter() {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            });
        }
    }
}
</script>
<style scoped>
.block--auth {
    background-color: #FFFFFF;
    border: 1px solid #F2F2F2;
    position: relative;
    width: 100%;
    max-width: 400px;
    padding: 30px;
}

.block--auth-title {
    background-color: $green;
    padding: 15px 30px;
    margin-top: -30px;
    margin-left: -30px;
    margin-right: -30px;
    margin-bottom: 30px;
    font-family: "Brandon Regular", Helvetica, sans-serif;
    font-size: 14px;
    text-transform: uppercase;
    color: $white;
    letter-spacing: 1px;
    position: relative;
}

.block--auth-large {
    max-width: 100%;
    margin-bottom: 30px;
}

.block--auth h5 {
    font-family: "Brandon Regular", Helvetica, sans-serif;
    font-weight: 400;
    font-size: 15px;
    margin-bottom: 15px;
    color: #000000;
    width: 100%;
    position: relative;
}

.block--auth h5 span {
    top: 50%;
    right: 0;
    transform: translatey(-50%);
}

.block--auth .row:first-of-type {
    margin-top: 0;
}

.block--auth h6 {
    font-family: "Brandon Regular", Helvetica, sans-serif;
    font-weight: 400;
    font-size: 20px;
    margin-bottom: 5px;
    color: #000000;
    width: 100%;
    position: relative;
}

section.section__content--page p {
    font-family: "Arno Pro", Times New Roman, serif;
    font-size: 18px;
    line-height: 171%;
}

</style>
